import React from 'react';
import { Tree as DesignTree } from '@whalecloud/fdx';
import FormItem from '@whalecloud/page-builder-core/components/FormItem';

const Tree = (props: any) => {
  const { element, elementStyle } = props;
  const { formSettings, formItemSettings, settings, className = '' } = element.data;
  const { visible } = settings;
  const { treeData, autoInitialize } = formItemSettings;

  return (
    <FormItem
      id={element.id}
      style={{
        ...elementStyle,
        visibility: visible
      }}
      {...formSettings}
    >
      <DesignTree {...formItemSettings} className={className} treeData={autoInitialize ? treeData : []} />
    </FormItem>
  );
};

export default Tree;
